import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManagePackage/tab/Booking/Views/booking.html';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import Pager from '@/Pages/Admin/Modules/Common/Controllers/Pager';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import {TrekBookingModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/Booking/TrekBookingModel';


@WithRender
@Component({
    components: {
        Pager,
        'validation-error': ValidationError,
    },
})
export default class Booking extends Vue {
    protected ui: any = {};
    protected item: any = {};
    protected vars: any = {};
    protected searchData: any = {};

    constructor() {
        super();

        this.ui = {
            status: {
                isLoading: {
                    getDepartureList: false,
                    filterBooking: false,
                },
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
            },
            paging: {
                current_page: 1,
                last_page: 0,
                per_page: 0,
            },
        };
        this.item = {
            bookingList: new TrekBookingModel({}),
            bookingTypeList: [
                {id: 'booking', name: 'Booking'},
                {id: 'pre-booking', name: 'Pre-Booking'},
            ],
            paymentMethodList: [
                {id: 'manual', name: 'Manual'},
                {id: 'stripe', name: 'Stripe'},
            ],
            paymentStatusList: [
                {id: '0', name: 'Unpaid'},
                {id: '1', name: 'Paid'},
            ],

            filterDepartureList: [],
        };

        this.searchData = {
            bookingType: '',
            departureDate: '',
            paymentStatus: '',
            name: '',
            number: '',
            email: '',
            payment: '',
            startDate: '',
            endDate: '',
        };

        this.vars = {
            trek_id: 0,
            filterStartDate: '',
            filterEndDate: '',
            tempStart: '',
            tempEnd: '',
        };
    }

    public mounted() {
        this.checkTrekId();
        this.getBookingByFilter();
    }
    public checkTrekId() {
        if (this.$route.query.id) {
            this.getDepartureList();
        }
    }

    public getDepartureList() {
        this.vars.trek_id = this.$route.query.id;
        this.ui.status.isLoading.getDepartureList = true;
        let data = {
            trek_id: this.vars.trek_id,
        };
        trekService
            .departuresList(data)
            .then((res: any) => {
                this.item.filterDepartureList = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
                    this.ui.error.has_error = true;
                    this.ui.error.errors = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getDepartureList = false;
            });
    }

    public getBookingByFilter() {
        this.vars.trek_id = this.$route.query.id;
        this.vars.tempStart = new Date(this.searchData.startDate);
        this.vars.filterStartDate = this.vars.tempStart;

        this.vars.tempEnd = new Date(this.searchData.endDate);
        this.vars.filterEndDate = this.vars.tempEnd;

        let data = {
            paging:
                {
                    current_page: this.ui.paging.current_page,
                    last_page: this.ui.paging.last_page,
                    per_page: this.ui.paging.per_page,
                },
            search: {
                trek_id: this.vars.trek_id,
                departure_id: this.searchData.departureDate.id,
                type: this.searchData.bookingType,
                payment_method: this.searchData.payment,
                payment_status: this.searchData.paymentStatus,
                start_date: this.vars.filterStartDate,
                end_date: this.vars.filterEndDate,
                customer_name: this.searchData.name,
                email: this.searchData.email,
                contact_number: this.searchData.number,
            },
            sorting: {
                sort_by: 'trek_id',
                sort_order: 'desc',
            },
        };
        this.ui.status.isLoading.filterBooking= true;
        trekService
            .searchBookiingByFilter(data)
            .then((res: any) => {
                this.ui.paging.last_page = res.data.data.last_page;
                this.ui.paging.per_page = res.data.data.per_page;
                let list: any = [];
                res.data.data.data.forEach((item: any) => {
                    list.push(item);
                });
                this.item.bookingList = list;
                this.ui.status.isLoading.filterBooking = false;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message)
                    .then((res: any) => {
                        this.ui.error.has_error = true;
                        this.ui.error.error_message = res;
                    });
            });
    }

    public toggleFilter() {
        $('.filter-body').slideToggle('medium');
        $('.filter-head').toggleClass('up');
    }

    public openAdvanceFilter() {
        $('.advance-filter').slideToggle('medium');
    }

    // clear all Filter
    public clearAllFilter() {
        this.searchData.bookingType = '';
        this.searchData.departureDate = '';
        this.searchData.paymentStatus = '';
        this.searchData.name = '';
        this.searchData.number = '';
        this.searchData.email = '';
        this.searchData.payment = '';
        this.searchData.startDate = '';
        this.searchData.endDate = '';
        this.searchData.trek = '';
        this.getBookingByFilter();
    }

    public viewDetail(index: any, item: any) {
        this.$router.push({
            name: 'create-business-package-trek-booking-view',
            query: {
                id: this.$route.query.id,
                bid: item.id,
            },
        });
    }

    protected onPaging(CurrentPage: number) {
        this.ui.paging.current_page = CurrentPage;
        this.getBookingByFilter();
    }
}
